"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFastTrackedCountry = exports.fastTrackedCountry = exports.EUcountries = void 0;
const domain_1 = require("@govtechsg/singpass-myinfo-oidc-helper/dist/myinfo/domain");
exports.EUcountries = [
    domain_1.MyInfoCountryPlaceCode.AUSTRIA,
    domain_1.MyInfoCountryPlaceCode.BELGIUM,
    domain_1.MyInfoCountryPlaceCode.BULGARIA,
    domain_1.MyInfoCountryPlaceCode.CROATIA,
    domain_1.MyInfoCountryPlaceCode.CYPRUS,
    domain_1.MyInfoCountryPlaceCode.CZECH_REPUBLIC,
    domain_1.MyInfoCountryPlaceCode.DENMARK,
    domain_1.MyInfoCountryPlaceCode.ESTONIA,
    domain_1.MyInfoCountryPlaceCode.FINLAND,
    domain_1.MyInfoCountryPlaceCode.FRANCE,
    domain_1.MyInfoCountryPlaceCode.GERMANY,
    domain_1.MyInfoCountryPlaceCode.GREECE,
    domain_1.MyInfoCountryPlaceCode.HUNGARY,
    domain_1.MyInfoCountryPlaceCode.IRELAND,
    domain_1.MyInfoCountryPlaceCode.ITALY,
    domain_1.MyInfoCountryPlaceCode.LATVIA,
    domain_1.MyInfoCountryPlaceCode.LITHUANIA,
    domain_1.MyInfoCountryPlaceCode.LUXEMBOURG,
    domain_1.MyInfoCountryPlaceCode.MALTA,
    domain_1.MyInfoCountryPlaceCode.NETHERLANDS,
    domain_1.MyInfoCountryPlaceCode.POLAND,
    domain_1.MyInfoCountryPlaceCode.PORTUGAL,
    domain_1.MyInfoCountryPlaceCode.ROMANIA,
    domain_1.MyInfoCountryPlaceCode.SLOVAK_REPUBLIC,
    domain_1.MyInfoCountryPlaceCode.SLOVENIA,
    domain_1.MyInfoCountryPlaceCode.SPAIN,
    domain_1.MyInfoCountryPlaceCode.SWEDEN,
];
exports.fastTrackedCountry = [
    domain_1.MyInfoCountryPlaceCode.MALAYSIA,
    domain_1.MyInfoCountryPlaceCode.AUSTRALIA,
    domain_1.MyInfoCountryPlaceCode.UNITED_STATES,
    domain_1.MyInfoCountryPlaceCode.UNITED_KINGDOM,
    domain_1.MyInfoCountryPlaceCode.CANADA,
    domain_1.MyInfoCountryPlaceCode.NEW_ZEALAND,
    ...exports.EUcountries,
];
const isFastTrackedCountry = (country) => {
    return !!country && exports.fastTrackedCountry.includes(country);
};
exports.isFastTrackedCountry = isFastTrackedCountry;
//# sourceMappingURL=fast-tracked-country.js.map